/** Where design-schedule serves the icon sprite — `/assets/icons/`, not the library's default `icons/`. */
const ICON_SPRITE_PATH = '/assets/icons/icons.sprite.svg';
const BUILD_VERSION_PARAM = 'v';
const EMPTY_LENGTH = 0;

/** The two build stamps the deploy writes into the environment; either may be empty, as in a local build. */
type IconSpriteBuild = {
	readonly release: string;
	readonly commitId: string;
};

/**
 * The icon sprite's path, carrying the build version, so a release's new icons are fetched at once
 * instead of being looked up in a sprite the browser cached under the same URL for up to 12 hours.
 * The release names the build, the commit stands in for it; with neither the path stays bare.
 */
export function iconSpritePath(build: IconSpriteBuild): string {
	const version = [build.release, build.commitId].find(stamp => stamp.length > EMPTY_LENGTH);

	if (version === undefined) {
		return ICON_SPRITE_PATH;
	}

	return `${ICON_SPRITE_PATH}?${BUILD_VERSION_PARAM}=${encodeURIComponent(version)}`;
}
